export default __webpack_public_path__ + "static/media/Group 123.32335972.svg";